/**
 * Get Recently Viewed Products Action
 * Triggered by: arc:action:recentlyViewedGet
 */

import shopifyHelper from "@js/utils/shopify";

const COOKIE_NAME = 'arc_recently_viewed';

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}

export const runRecentlyViewedGet = async (data = {}) => {
    try {
        const { limit = 10 } = data;

        const ids = JSON.parse(getCookie(COOKIE_NAME) || '[]');

        if (ids.length === 0) {
            return {
                success: true,
                products: [],
                total: 0,
                message: 'No recently viewed products found'
            };
        }

        const products = await shopifyHelper.getShopifyProductList(ids);
        const validProducts = (products || []).filter(product => product && product.id);
        const limitedProducts = limit ? validProducts.slice(0, limit) : validProducts;

        window.dispatchEvent(new CustomEvent('recentlyViewed:fetched', {
            detail: {
                products: limitedProducts,
                total: validProducts.length
            }
        }));

        return {
            success: true,
            products: limitedProducts,
            total: validProducts.length,
            message: 'Recently viewed products retrieved successfully'
        };

    } catch (error) {
        console.error('Recently Viewed Get error:', error);

        window.dispatchEvent(new CustomEvent('recentlyViewed:error', {
            detail: {
                error: error.message,
                action: 'get'
            }
        }));

        return {
            success: false,
            error: error.message,
            products: []
        };
    }
};

export default runRecentlyViewedGet;
